import { render, staticRenderFns } from "./sign-block.vue?vue&type=template&id=62637d85&scoped=true&lang=pug&"
import script from "./sign-block.vue?vue&type=script&lang=js&"
export * from "./sign-block.vue?vue&type=script&lang=js&"
import style0 from "./sign-block.vue?vue&type=style&index=0&id=62637d85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62637d85",
  null
  
)

export default component.exports